import { render } from "./Al GALALAH Resort.vue?vue&type=template&id=7620bd22&scoped=true"
const script = {}

import "./Al GALALAH Resort.vue?vue&type=style&index=0&id=7620bd22&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7620bd22"

export default script